export default "__VITE_ASSET__yS3Bl6Un__"